export enum DashboardWidgetHeaderBlock {
  Root = 'DashboardWidgetHeader',
}

export enum DashboardWidgetHeaderElement {
  Link = 'link',
  Title = 'title',
}
